import React from "react";
import { AlertCircle } from "lucide-react";
import { INK, INK_3, LINE, OK_INK, WARN_INK, BAD_INK } from "../bureauTokens";

const TONE_BAR = {
  ok: OK_INK,
  warn: WARN_INK,
  bad: BAD_INK,
};

const TONE_ALERT = {
  ok: OK_INK,
  warn: WARN_INK,
  bad: BAD_INK,
};

// placeholder=true : tuile visuellement neutre pour un KPI pas encore
// branché sur de vraies données (ex. Bilans/TVA en retard, voir plan Bureau)
// — pas de faux chiffre affiché.
// loading=true : squelette pendant le chargement initial des données
// globales (EtatGlobal.js isLoading) — évite d'afficher "0" le temps que
// todos/traitementsComptablesData/juridiquePonctuelleData/suiviJuridiqueData
// arrivent.
function KpiTile({ label, value, sub, tone = "ok", onClick, placeholder, loading }) {
  if (loading) {
    return (
      <div
        className="p-3.5 min-h-[92px]"
        style={{ background: "#fff", border: `1px solid ${LINE}`, borderRadius: 14 }}
      >
        <div className="h-5 w-9 rounded animate-pulse" style={{ background: LINE }} />
        <div className="h-2.5 w-20 rounded animate-pulse mt-2.5" style={{ background: LINE }} />
        <div className="h-2 w-14 rounded animate-pulse mt-1.5" style={{ background: LINE }} />
      </div>
    );
  }

  if (placeholder) {
    return (
      <div
        className="p-3.5 flex flex-col items-center justify-center text-center min-h-[92px]"
        style={{ background: "#fff", border: `1px solid ${LINE}`, borderRadius: 14 }}
      >
        <div className="text-[11px]" style={{ color: INK_3 }}>
          {label}
        </div>
      </div>
    );
  }

  return (
    <button
      onClick={onClick}
      className="relative text-left p-3.5 overflow-hidden transition-shadow hover:shadow-sm"
      style={{ background: "#fff", border: `1px solid ${LINE}`, borderRadius: 14 }}
    >
      <span
        className="absolute left-0 top-0 bottom-0"
        style={{ width: 4, background: TONE_BAR[tone] || TONE_BAR.ok }}
      />
      {tone === "bad" && value > 0 && (
        <AlertCircle
          size={15}
          className="absolute top-[9px] right-[9px]"
          style={{ color: TONE_ALERT[tone] }}
        />
      )}
      <div className="text-lg font-bold leading-none" style={{ color: INK }}>
        {value}
      </div>
      <div className="text-[11px] font-semibold mt-1.5" style={{ color: INK }}>
        {label}
      </div>
      {sub && (
        <div className="text-[10px] mt-0.5" style={{ color: INK_3 }}>
          {sub}
        </div>
      )}
    </button>
  );
}

export default KpiTile;
